var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acomodar"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row w-100"},[_c('DatoPersonal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }